import { Icon, svgIcons } from '@exploration/icons';
import { useTheme } from 'styled-components';

export const PrimaryLinkArrow = () => {
  const { midwestColors } = useTheme();

  return (
    <Icon
      icon={svgIcons.arrowRight}
      height={16}
      width={16}
      colorPrimary={midwestColors.sentimentNegativeStrong}
    />
  );
};
